import { qz } from "../client";
import { createNamespaceMutation } from "../internal/createNamespaceMutation";
import {
  markUsbClaimed,
  markUsbStreamClosed,
  markUsbStreamOpened,
  usbStore,
} from "./state";
import {
  type UsbClaimInput,
  type UsbCloseStreamInput,
  type UsbOpenStreamInput,
  type UsbReadInput,
  type UsbReleaseInput,
  type UsbSendInput,
} from "./types";

export const usbClaimDeviceMutationOptions = createNamespaceMutation({
  key: ["qz.usb.claimDevice"],
  run: async (deviceInfo: UsbClaimInput) => {
    await qz.usb.claimDevice(deviceInfo);
    markUsbClaimed(deviceInfo, true);
  },
  store: usbStore,
});

export const usbReleaseDeviceMutationOptions = createNamespaceMutation({
  key: ["qz.usb.releaseDevice"],
  run: async (deviceInfo: UsbReleaseInput) => {
    await qz.usb.releaseDevice(deviceInfo);
    markUsbClaimed(deviceInfo, false);
    markUsbStreamClosed(deviceInfo);
  },
  store: usbStore,
});

export const usbOpenStreamMutationOptions = createNamespaceMutation({
  key: ["qz.usb.openStream"],
  run: async (deviceInfo: UsbOpenStreamInput) => {
    await qz.usb.openStream(deviceInfo);
    markUsbStreamOpened(deviceInfo);
  },
  store: usbStore,
});

export const usbCloseStreamMutationOptions = createNamespaceMutation({
  key: ["qz.usb.closeStream"],
  run: async (deviceInfo: UsbCloseStreamInput) => {
    await qz.usb.closeStream(deviceInfo);
    markUsbStreamClosed(deviceInfo);
  },
  store: usbStore,
});

export const usbReadDataMutationOptions = createNamespaceMutation({
  key: ["qz.usb.readData"],
  run: (deviceInfo: UsbReadInput) => qz.usb.readData(deviceInfo),
  store: usbStore,
});

export const usbSendDataMutationOptions = createNamespaceMutation({
  key: ["qz.usb.sendData"],
  run: async (deviceInfo: UsbSendInput) => {
    await qz.usb.sendData(deviceInfo);
  },
  store: usbStore,
});
